import { render } from "./AdminClubsPage.vue?vue&type=template&id=59fd7119&scoped=true"
import script from "./AdminClubsPage.vue?vue&type=script&lang=js"
export * from "./AdminClubsPage.vue?vue&type=script&lang=js"

import "./AdminClubsPage.vue?vue&type=style&index=0&id=59fd7119&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59fd7119"]])

export default __exports__